import NotFount from '@/assets/images/workspace/workspace-404.jpg'
import { Button } from '@/shared/components/ui/button'
import { useNavigate } from 'react-router-dom'
import { WorkspaceLayout } from './WorkspaceLayout'
const WorkspaceNotFound = () => {
    const navigate = useNavigate()

    return (
        <WorkspaceLayout>
            <div className="flex flex-col items-center justify-center h-full px-4 text-center max-w-xl mx-auto">
                <div className="text-red-600 rounded-full p-4 shadow-md mb-6">
                    <img src={NotFount} />
                </div>
                <h1 className="text-3xl font-bold text-foreground mb-2">Workspace Not Found</h1>
                <p className="text-muted-foreground mb-6">
                    The workspace you're looking for doesn't exist or may have been deleted.
                </p>
                <Button onClick={() => navigate('/dashboard')} variant="default">
                    Go to Dashboard
                </Button>
            </div>
        </WorkspaceLayout>
    )
}

export default WorkspaceNotFound
